import { IconError } from "@icons/index";
import classNames from "classnames";
import { Trans } from "react-i18next";
import CommonButton from "@components/CommonButton";

export interface ErrorProps {
  showIcon?: boolean;
  className?: string;
  reload?: () => void;
  traceID?: string;
}

export default ({ className, showIcon = true, reload, traceID }: ErrorProps) => {
  return (
    <div className={classNames("Component-Section-Error", className)}>
      {showIcon && <IconError className="icon"></IconError>}
      <div className="error-text text-center">
        <Trans>Something went wrong. Please try again.</Trans>
      </div>
      {traceID && (
        <div className="traceID">
          <Trans>Trace ID</Trans>:{traceID}
        </div>
      )}
      {reload && (
        <CommonButton className="min-w-[90px] h-[36px] mt-[24px]" type="primary" onClick={() => reload()}>
          <Trans>Reload</Trans>
        </CommonButton>
      )}
    </div>
  );
};
